// Solo presentazione (valori invariati): formato italiano per importi e percentuali.
const NUM = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 0, useGrouping: "always" });
const DEC = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 1 });

export const eurIt = (v) => (v == null ? null : `${Math.round(v) < 0 ? "−" : ""}${NUM.format(Math.abs(Math.round(v)))} €`);
export const decIt = (v) => (v == null ? null : DEC.format(v));

const grp = (n) => NUM.format(Number(n.replace(/[.,]/g, "")));
const SFX = /(?<![\d.,])([-−])?(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d{1,2}))?\s?€/g;
const PFX = /([-−])?€\s?(\d{1,3}(?:,\d{3})+(?!\d)|\d{1,3}(?:\.\d{3})+|\d+)(,\d+)?/g;
const PCT = /(?<![\d.,])(-)?(\d+)(?:\.(\d+))?%/g;

// 6,168€ → 6.168 € · € 8.157 → 8.157 € · -2.2% → −2,2%
export const itText = (s) =>
  (s || "")
    .replace(SFX, (_, neg, n, d) => `${neg ? "−" : ""}${grp(n)}${d ? `,${d}` : ""} €`)
    .replace(PFX, (_, neg, n, d) => `${neg ? "−" : ""}${grp(n)}${d || ""} €`)
    .replace(PCT, (_, neg, a, b) => `${neg ? "−" : ""}${a}${b ? `,${b}` : ""}%`);
